var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1459e1c32dbafa7311427fd8c6fa4dc3.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/576db3d2f2adfa1ed0308d124c2090b8.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5e42401cbd61ffd5a6de584e4e199d18.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    